import React from "react";
import { Select } from "antd";

const { Option } = Select;

const SequenceSelector = ({ sequences, value, onChange }) => {
	const last = sequences[sequences.length - 1];

	return (
		<Select value={value} onChange={onChange}>
			{sequences.map((t) => (
				<Option key={t.id} value={t.sequence}>
					{`Before ${t.user?.fullName ?? "Unknown"} (${
						t.role?.title
					})`}
				</Option>
			))}
			<Option value={last?.sequence + 1}>
				{`After ${last?.user?.fullName ?? "Unknown"} (${
					last?.role?.title
				})`}
			</Option>
		</Select>
	);
};

export default SequenceSelector;
